/**
 * FormAssignment model translations
 *
 * Translation keys follow the pattern: models.form-assignment.{category}.{key}
 */
export default {
    en: {
        singular: "Form Assignment",
        plural: "Form Assignments",

        fields: {
            status: "Status",
            assignee: "Assignee",
            assigned_to_user_id: "Assigned To",
            assigned_by_user_id: "Assigned By",
            form: "Form",
            "form.title": "Form Title",
            due_at: "Due Date",
            started_at: "Started",
            completed_at: "Completed",
            task_id: "Task",
            party_id: "Party",
            client_id: "Client",
            schedule_id: "Schedule",
            communication_id: "Communication",
            communication_recipient_id: "Recipient",
            source_type: "Source",
            created_at: "Created",
        },

        tabs: {
            details: "Details",
        },

        badges: {
            pending: "Pending",
            in_progress: "In Progress",
            completed: "Completed",
            withdrawn: "Withdrawn",
            expired: "Expired",
            cancelled: "Cancelled",
        },

        actions: {
            assign: "Assign",
            withdraw: "Withdraw",
            cancel: "Cancel",
        },

        filters: {
            status: "Status",
        },
    },

    fr: {
        singular: "Attribution de formulaire",
        plural: "Attributions de formulaire",

        fields: {
            status: "Statut",
            assignee: "Responsable",
            assigned_to_user_id: "Attribue a",
            assigned_by_user_id: "Attribue par",
            form: "Formulaire",
            "form.title": "Titre du formulaire",
            due_at: "Date limite",
            started_at: "Commence le",
            completed_at: "Termine le",
            task_id: "Tache",
            party_id: "Partie",
            client_id: "Client",
            schedule_id: "Horaire",
            communication_id: "Communication",
            communication_recipient_id: "Destinataire",
            source_type: "Source",
            created_at: "Cree le",
        },

        tabs: {
            details: "Details",
        },

        badges: {
            pending: "En attente",
            in_progress: "En cours",
            completed: "Termine",
            withdrawn: "Retire",
            expired: "Expire",
            cancelled: "Annule",
        },

        actions: {
            assign: "Attribuer",
            withdraw: "Retirer",
            cancel: "Annuler",
        },

        filters: {
            status: "Statut",
        },
    },
};
